//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Paymentbar",
  component: {},
  data() {
    return {
      payIndex:0,
      payList:[{
        name:'累计实收',
        value:0,
        color:'',
        isEllipsis:false
      },{
        name:'累计逾期',
        value:0,
         color:'',
         isEllipsis:false
      },{
        name:'累计未到期',
        value:0,
        color:'',
        isEllipsis:false
      }],
      showHover:false,
      hoverIndex:0
    };
  },
   watch:{
     paymentBarBean:{
       handler:function(newval,oldval){
          console.log('paymentBarBean',this.paymentBarBean)
          if(this.paymentBarBean){
              //  this.payList[0].value=9999999999999999999999999999999999;
                this.payList[0].value=this.paymentBarBean.proceedsAmount;
               this.payList[0].color=this.paymentBarBean.proceedsColor;
              //  this.payList[2].value=88888;
               this.payList[2].value=this.paymentBarBean.notOverdueAmount;
               this.payList[2].color=this.paymentBarBean.notOverdueColor;
              //  this.payList[1].value=99999999999999999;
               this.payList[1].value=this.paymentBarBean.overdueAmount;
               this.payList[1].color=this.paymentBarBean.overdueColor;
          }  
       },
       deep: true
     }

     
  },
   props: {
    paymentBarBean:Object,
    invoke: Function,
    model:Object
  },
  methods: {
    judge(){
            let isOverflow = this.$refs.isOverflow;
                for (let i in isOverflow) {
                    let cWidth = isOverflow[i].clientWidth;
                    let sWidth = isOverflow[i].scrollWidth;
                    console.log(i,cWidth,sWidth)
                    if (sWidth > cWidth) { //超过 
                        this.payList[i].isEllipsis=true
                    } else {
                        this.payList[i].isEllipsis=false
                    }
                }

    },
    mouseoverFn(n){
        this.showHover=true,
        this.hoverIndex=n
        this.judge()
    },
    initData(){
                  let value={}
                   let parm={content:{ type:'initData', value:value}}
                      console.log('initData传给后台的参数',parm)
                      this.invoke('invokeCustomEvent',parm) 
     
    },
    getBg(color){
       let bg='background-color:'+color
       return bg
    },
    getWidth(width){
         let widths=''
         let total=0;
         this.payList.forEach(element => {
           total+=element.value
         });
       if(width!=0){
         let widthp=(width/total)*100 

          widths='width:'+widthp+'%;'
       }
    
       return widths
    },
    change(n){
                 this.payIndex=n
                    let value={
                      type:n
                    }
                     let parm={content:{ type:'queryContractData', value:value}}
                      console.log('queryContractData传给后台的参数',parm)
                      this.invoke('invokeCustomEvent',parm) 
    }

  },
  created() {
    this.initData()
  },
};
